export const collapsibleSections = () => {
  const collapsibleSection = '.js-collapsible-section';
  const collapsibleSectionToggle = '.js-collapsible-section-toggle';
  const toggleareaHeight = '6.75em';

  const init = () => {
    bind();
  };

  const bind = () => {
    $(collapsibleSectionToggle).on('click', function(e) {
      e.preventDefault();
      $(this).closest(collapsibleSection).attr('data-state',
        $(this).closest(collapsibleSection).attr('data-state')=='closed' ? 'open' : 'closed'
      );
      if($(this).closest(collapsibleSection).attr('data-state') == 'open') {
        $(this).closest(collapsibleSection).css({'max-height':$(this).closest(collapsibleSection).children('.js-collapsible-section-content').outerHeight()});
      } else {


          $(this).closest(collapsibleSection).css({'max-height':toggleareaHeight});

      }
    });
  };

  init();

};
